export default "__VITE_ASSET__zDtb2Pf7__"